export enum FormCategory {
  VA_LANDOLT_DISTANCE_BINOC = 1,
  CRITICAL_FLICKER_FUSION_TEST = 2,
  MONOCHROME_CONTRAST_SENSITIVITY = 3,
  OTHER = 4,
}

export const CATEGORY_MAPPING: { [key in FormCategory]: string } = {
  [FormCategory.VA_LANDOLT_DISTANCE_BINOC]: 'va-landolt-distance-binoc',
  [FormCategory.CRITICAL_FLICKER_FUSION_TEST]: 'critical-flicker-fusion-test',
  [FormCategory.MONOCHROME_CONTRAST_SENSITIVITY]: 'monochrome-contrast-sensitivity',
  [FormCategory.OTHER]: 'other',
}

export const CATEGORY_OPTIONS = [
  { value: FormCategory.VA_LANDOLT_DISTANCE_BINOC, label: 'va-landolt-distance-binoc' },
  { value: FormCategory.CRITICAL_FLICKER_FUSION_TEST, label: 'critical-flicker-fusion-test' },
  { value: FormCategory.MONOCHROME_CONTRAST_SENSITIVITY, label: 'monochrome-contrast-sensitivity' },
  { value: FormCategory.OTHER, label: 'other' },
]

export const getCategoryLabel = (category: number): string => {
  return CATEGORY_MAPPING[category as FormCategory] || CATEGORY_MAPPING[FormCategory.OTHER]
}
